import Session from '../../models/session'
import Job from '../../models/job'

export default{
  namespaced: true,
  state: {
    all: []
  },
  getters: {
    empty: state => state.all.length === 0,
    sessions: state => state.all.map((d) => Session.fromJson(d)),
    today: (state, getters) => {
      return getters.sessions.filter(session => session.isToday())
    },
    current: (state, getters) => {
      return getters.sessions.filter(session => session.isCurrent())[0]
    },
    next: (state, getters) => {
      return getters.sessions.filter(session => session.isFuture()).sort((a, b) => a.isBefore(b))[0]
    },
    currentOrNext: (state, getters) => {
      const current = getters.current
      if (current !== null && current !== undefined) {
        return current
      }
      return getters.next
    },
    betweenSessions: (state, getters) => {
      return getters.today.length > 1 &&
        getters.current == null &&
        getters.today.filter((session) => session.isPast()).length > 0 &&
        getters.today.filter((session) => session.isFuture()).length > 0
    },
    betweenDays: (state, getters) => {
      if (getters.allOver) {
        return false
      }
      return getters.today.length > 0 &&
        getters.current == null &&
        getters.today.filter((session) => session.isFuture()).length === 0
    },
    future: (state, getters) => {
      return getters.sessions.filter(session => session.isFuture()).sort((a, b) => a.isBefore(b))
    },
    past: (state, getters) => {
      return getters.sessions.filter(session => session.isPast()).sort((a, b) => a.isBefore(b))
    },
    notStarted: (state, getters) => {
      return (getters.current === null || getters.current === undefined) && getters.past.length === 0
    },
    allOver: (state, getters) => {
      if (getters.sessions.length === 0) {
        return false
      }
      return getters.sessions.filter(session => session.isPast()).length === state.all.length
    }
  },
  mutations: {
    SET_ALL (state, sessions) {
      state.all = sessions
    }
  },
  actions: {
    async load ({commit}) {
      let sessions = await this.$api.getSessions()
      commit('SET_ALL', sessions)
      for (const idx in sessions) {
        let session = Session.fromJson(sessions[idx])
        let before = new Date(session.starts.getTime() - (60 * 60 * 1000))
        console.log(before)
        commit('jobs/ADD', {
          job: new Job(before, 'motions', 'load'),
          replace: false
        }, {
          root: true
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/sessions.js